import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login/Login";
import ProtectedRoute from "./ProtectedRoute";
const Admin = lazy(() => import("./pages/Admin/Admin"));
const SuiviBureau = lazy(() => import("./pages/SuiviBureau/SuiviBureau"));
const Archives = lazy(() => import("./pages/Admin/Archive"));
const LiteCalls = lazy(() => import("./pages/Display/LiteCalls"));
export default function Router() {
    const displayUser = String(new URLSearchParams(window.location.search).get("token") || "").toLowerCase() === "tableau";
    return (
        <Suspense fallback={<div style={{ minHeight: "100vh", background: "#07131f" }} />}>
        <Routes>
            <Route path="/" element={<Navigate to={displayUser ? "/affichage" : "/login"} />} />
            <Route path="/login" element={<Login />} />
            <Route
                path="/depannage"
                element={
                    <ProtectedRoute roles={['tech', 'bureau', 'admin']}>
                        <Admin />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/bureau"
                element={
                    <ProtectedRoute roles={['bureau', 'admin']}>
                        <SuiviBureau />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/admin/archives"
                element={<ProtectedRoute roles={['bureau', 'admin', 'tech']}>
                    <Archives /> </ProtectedRoute>}
            />

            <Route
                path="/affichage"
                element={<ProtectedRoute roles={['tech', 'bureau', 'admin']}><LiteCalls /></ProtectedRoute>}
            />

        </Routes>
        </Suspense>
    );
}
